export default __webpack_public_path__ + "static/media/cryptoinfo.71b44ebc.png";